package br.com.htms.inspeccaocampo.shared.ui.components

import br.com.htms.inspeccaocampo.ui.kit.LinhaOpcoes
import br.com.htms.inspeccaocampo.ui.theme.PortalCores
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.RadioButton
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.semantics.Role
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import br.com.htms.inspeccaocampo.data.FotoAnexo
import br.com.htms.inspeccaocampo.data.ItemCampoPersonalizado
import br.com.htms.inspeccaocampo.data.RespostaTernaria

@Composable
fun ItemCampoPersonalizadoCard(
    item: ItemCampoPersonalizado,
    indice: Int,
    erro: String?,
    onTitulo: (String) -> Unit,
    onResposta: (RespostaTernaria?) -> Unit,
    onJustificativa: (String) -> Unit,
    onTirarFoto: () -> Unit,
    onAdicionarMaisFoto: () -> Unit,
    onRemoverFoto: (FotoAnexo) -> Unit,
    onGaleria: (() -> Unit)? = null,
    onRemoverItem: (() -> Unit)? = null,
    modifier: Modifier = Modifier
) {
    var mostrarLista by remember { mutableStateOf(false) }
    val rotulo = item.rotuloSequencia(indice)

    Card(
        modifier = modifier.fillMaxWidth(),
        colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.surface), border = PortalCores.BordaCartao
    ) {
        Column(Modifier.padding(12.dp), verticalArrangement = Arrangement.spacedBy(8.dp)) {
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically
            ) {
                Column(modifier = Modifier.weight(1f)) {
                    Text(rotulo, fontWeight = FontWeight.SemiBold, color = PortalCores.Navy)
                    Text(
                        "Opcional — não impede salvar se estiver vazio.",
                        style = MaterialTheme.typography.bodySmall,
                        color = MaterialTheme.colorScheme.onSurfaceVariant
                    )
                }
                if (onRemoverItem != null) {
                    TextButton(onClick = onRemoverItem) {
                        Text("Remover")
                    }
                }
            }

            AppOutlinedTextField(
                value = item.titulo,
                onValueChange = onTitulo,
                label = { Text("Nome do item (opcional)") },
                modifier = Modifier.fillMaxWidth(),
                colors = FormFieldDefaults.textFieldColors()
            )

            LinhaOpcoes(
                opcoes = RespostaTernaria.entries,
                selecionada = item.resposta,
                rotulo = { it.rotulo },
                cor = ::corTernaria,
                onSelect = { opcao -> onResposta(if (item.resposta == opcao) null else opcao) }
            )

            when (item.resposta) {
                RespostaTernaria.SIM -> {
                    CampoFotoRow(
                        label = "Foto (opcional)",
                        obrigatorio = false,
                        quantidadeFotos = item.fotos.size,
                        onTirarFoto = onTirarFoto,
                        onAdicionarMais = onAdicionarMaisFoto,
                        onAbrirLista = { mostrarLista = true },
                        onGaleria = onGaleria
                    )
                }
                RespostaTernaria.NAO -> {
                    AppOutlinedTextField(
                        value = item.justificativa,
                        onValueChange = onJustificativa,
                        label = { Text("Justificativa (opcional)") },
                        modifier = Modifier.fillMaxWidth(),
                        minLines = 2,
                        colors = FormFieldDefaults.textFieldColors(),
                        isError = erro != null
                    )
                    CampoFotoRow(
                        label = "Foto (opcional)",
                        obrigatorio = false,
                        quantidadeFotos = item.fotos.size,
                        onTirarFoto = onTirarFoto,
                        onAdicionarMais = onAdicionarMaisFoto,
                        onAbrirLista = { mostrarLista = true },
                        onGaleria = onGaleria
                    )
                }
                RespostaTernaria.NA -> {
                    AppOutlinedTextField(
                        value = item.justificativa,
                        onValueChange = onJustificativa,
                        label = { Text("Justificativa (opcional)") },
                        modifier = Modifier.fillMaxWidth(),
                        minLines = 2,
                        colors = FormFieldDefaults.textFieldColors(),
                        isError = erro != null
                    )
                }
                null -> Unit
            }

            erro?.let {
                Text(it, color = MaterialTheme.colorScheme.error, style = MaterialTheme.typography.bodySmall)
            }
        }
    }

    if (mostrarLista) {
        SharedFotosMenu(
            titulo = "$rotulo — fotos",
            fotos = item.fotos,
            aberto = true,
            onFechar = { mostrarLista = false },
            onRemover = onRemoverFoto
        )
    }
}
